import React, { useEffect } from 'react';
import { trackLandingPageModuleClick } from '../../../../../tracking/landing-page';
import type { FaaLandingPageModule } from '../../../../../tracking/landing-page';
import * as styles from '../call-to-actions.style';

interface CtaItemProps {
  module: FaaLandingPageModule;
  icon: React.ReactNode;
  href: string;
  children: React.ReactNode;
  testId?: string;
  onModuleRendered?: (module: FaaLandingPageModule) => void;
  onAdditionalClick?: () => void;
}

const CtaItem = ({
  module,
  icon,
  href,
  children,
  testId,
  onModuleRendered,
  onAdditionalClick,
}: CtaItemProps): JSX.Element => {
  useEffect(() => {
    onModuleRendered?.(module);
  }, [module, onModuleRendered]);

  const handleClick = (): void => {
    onAdditionalClick?.();
    trackLandingPageModuleClick(module);
  };

  return (
    <li css={styles.ctaItem}>
      <a
        css={styles.ctaLink}
        data-testid={testId}
        href={href}
        onClick={handleClick}
        onAuxClick={handleClick}
      >
        <div css={styles.ctaIcon}>{icon}</div>
        {children}
      </a>
    </li>
  );
};

export default CtaItem;
